define('services/service.runapp',[],
    function (app, dialog) {

    	var service = {};

    	service.run = function (controls, url, callback) {
    	    if (bowser.name == "Chrome") {
    	        var el = $(controls.find("#protocol-input"));

    	        runChrome(el, url, function (b) {
                    //as per FPA-1512 - remove dialog. this is for demo purpose. issue with chrome
    	            //if (!b) {
    	            //    require(['plugins/dialog'], function (dialog) {
    	            //        dialog.show("modals/secured/explorer/results/ProtocolNotFoundModal");
    	            //    });   	                
    	            //}
    	        });
    	    }
    	    if (bowser.name == "Internet Explorer") {
    	        var el = $(controls.find("#protocol-link"));

    	        runIE(el, url, function (b) {
    	            if (!b) {
    	                require(['plugins/dialog'], function (dialog) {
    	                    dialog.show("modals/secured/explorer/results/ProtocolNotFoundModal");
    	                });
    	            }
    	        });
    	    }
    	    if (bowser.name == "") {

    		}
    	    if (bowser.name == "") {

    		}
    	};
    	service.detectPlugin = function (ifinstalled, ifnotinstalled) {
    	    //require(['services/service.runapp'], function (svc) {
    	    //    svc.detectPlugin(
            //        function () {
            //            alert('installed');
            //        },
            //        function () {
            //            alert('not installed');
            //        });
    	    //});
    	    if (bowser.name == "Chrome") {
    	        var id = 'fileplan-chrome-ex-id';

    	        detectChromeExtention('chrome-extension://' + id ,ifinstalled, ifnotinstalled);
    	    }
    	};

    	return service;

    	function detectChromeExtention(base, ifinstalled, ifnotinstalled) {
    	    var s = document.createElement('script');

    	    s.onload = ifinstalled;
    	    s.onerror = ifnotinstalled;

    	    document.body.appendChild(s);
    	    
    	    s.src = base + '/manifest.json';
    	}

    	function runChrome(el, url, callback) {
    	    var success = false;

    	    el.focus();

    	    el.blur(function () {
    	        success = true;
    	        callback(true);
    	    });

    	    location.href = url;

    	    setTimeout(function () {
    	        el.off("blur");
    	        //el.removeAttr("tabindex");

    	        if (!success) {
    	            callback(false);
    	        }
    	    }, 100);
    	}
    	function runIE(el, url, callback) {    	    
    	    el.href = url;
    	    
    	    //if (el.protocolLong == "Unknown Protocol") {
    	    //    callback(false);
    	    //    return;
    	    //}

    	    function tryWindow() {
    	        var isSupported = false;
    	        var myWindow = window.open('', '', 'width=20px,height=20px');
    	        //myWindow.document.write('<iframe src="' + url + '"></iframe>');

    	        setTimeout(function () {
    	            try {
    	                myWindow.location.href = url;
    	                isSupported = true;
    	            }
    	            catch (e) {
    	            }

    	            if (isSupported) {
    	                myWindow.setTimeout('window.close', 100);
    	            } else {
    	                myWindow.close();
    	            }

    	            callback(isSupported);
    	        }, 100);
    	    }

    	    if (window.navigator.msLaunchUri) {
    	        window.navigator.msLaunchUri(url,
                    function () {
                        callback(true);
                    },
                    function () {                        
                        callback(false);
                    });    	        
    	    } else {
    	        tryWindow();
            }
    	}
    }
);
